import { Skeleton } from '@/components/ui/skeleton';

export function OtpCodeFormSkeleton() {
  return (
    <div className="flex flex-col gap-3.5 my-8" aria-busy="true" aria-live="polite">
      <div className="flex flex-col items-center text-center">
        <Skeleton className="h-10 w-10 rounded-full mb-3.5" />
        <Skeleton className="h-7 w-48 mb-2" />
        <Skeleton className="h-4 w-64" />
      </div>
      <div className="grid grid-cols-6 gap-3.5 my-3.5">
        {Array.from({ length: 6 }).map((_, i) => (
          <Skeleton key={i} className="h-14" />
        ))}
      </div>
      <Skeleton className="h-3 w-40 mx-auto" />
      <Skeleton className="h-4 w-44 mx-auto" />
      <Skeleton className="h-12 w-full rounded-[2px]" />
    </div>
  );
}
